import { gql } from '@apollo/client';
import { ExternalLinkBlock, InternalLinkBlock } from './link';

export const CallToActionBlock = gql`
    fragment CallToActionBlock on CallToActionRecord {
        __typename
        title
        subtitle
        link {
            ...InternalLinkBlock
            ...ExternalLinkBlock
        }
    }
    ${InternalLinkBlock}
    ${ExternalLinkBlock}
`;
